import { createRouter, createWebHashHistory } from 'vue-router';

import { usePreventNavigationHelper } from './composables/usePreventNavigationHelper';
import { authRoute } from './layouts/auth/routes';
import { noauthRoute } from './layouts/noauth/routes';

const { confirmNavigation } = usePreventNavigationHelper();

export const router = createRouter({
    history: createWebHashHistory(),
    routes: [authRoute, noauthRoute]
});

router.beforeEach(async () => {
    return confirmNavigation();
});

// Add if not using client manager
const KC_PARAM_CODE = /[&?]code=[^&$]*/;
const KC_PARAM_STATE = /[&?]state=[^&$]*/;
const KC_PARAM_SESSION_STATE = /[&?]session_state=[^&$]*/;
const KC_PARAMS_REGEX = new RegExp(`(${KC_PARAM_CODE.source})|(${KC_PARAM_STATE.source})|(${KC_PARAM_SESSION_STATE.source})`);

router.beforeEach((to, from) => {
    if (KC_PARAMS_REGEX.test(to.fullPath)) {
        return cleanPathFromKCParams(to.fullPath);
    } else {
        return true;
    }
});

function cleanPathFromKCParams(path: string): string {
    return path.replace(KC_PARAM_CODE, '').replace(KC_PARAM_STATE, '').replace(KC_PARAM_SESSION_STATE, '');
}
